import { render, staticRenderFns } from "./CandidateRemoveWarning.vue?vue&type=template&id=248cd934&scoped=true"
import script from "./CandidateRemoveWarning.vue?vue&type=script&lang=js"
export * from "./CandidateRemoveWarning.vue?vue&type=script&lang=js"
import style0 from "./CandidateRemoveWarning.vue?vue&type=style&index=0&id=248cd934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cd934",
  null
  
)

export default component.exports